import React from 'react';
import { SectionLabel } from './SectionLabel';
import { Bloom } from './Bloom';
import { PipelineBoardVisual } from './visuals/PipelineBoardVisual';
import { crmFeatures } from '../data/howItWorks';

/* Replaces the generic FeatureSection (four text-only cards) with the same
   label/heading/body pattern used elsewhere, paired with the actual
   pipeline board mockup instead of another card grid -- this is the single
   highest-value section to make visual, since "every lead and job in one
   place" is a claim best shown, not told. Stacked (not side-by-side) so
   the four-column board keeps its width instead of being squeezed into
   half the page. */
export function CrmSection() {
  return <section className="relative isolate overflow-hidden border-b border-[#1a1a1a] bg-[#0c0c0c]" data-id="element-207" data-mp="2s9sigj4xmcrm">
      <Bloom size="md" className="left-0 top-[-6rem]" data-id="element-208" data-mp="1bvk8do1clvwv" />
      <div className="mx-auto w-full max-w-6xl px-6 py-20 lg:py-24" data-id="element-209" data-mp="1by6invfmipis">
        <SectionLabel data-id="element-210" data-mp="1gvy88isspzjt">The CRM</SectionLabel>
        <h2 className="mt-8 max-w-2xl text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-211" data-mp="j8gv111nhjmp">
          Every lead and every job in one place.
        </h2>
        <p className="mt-5 max-w-2xl text-lg leading-relaxed text-neutral-400" data-id="element-212" data-mp="eb89cqhamxgp">
          Nothing lives in a notebook on the dash or a text thread you scroll back through at
          9pm. Here&rsquo;s the board it actually runs on.
        </p>

        <div className="mt-10" data-id="element-213" data-mp="126t3ekkqmph8">
          <PipelineBoardVisual data-id="element-214" data-mp="1261ic3oroa57" />
        </div>

        <ul className="mt-10 grid grid-cols-1 gap-x-10 gap-y-3 sm:grid-cols-2" data-id="element-215" data-mp="x89fwfqhx5mr">
          {crmFeatures.map(f => <li key={f.title} className="flex gap-3 text-sm leading-relaxed text-neutral-300" data-id="element-216" data-mp="1b063q7l4stdc">
              <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-500" aria-hidden="true" data-id="element-217" data-mp="16xj9y14wgydi" />
              <span data-id="element-218" data-mp="1ky3ryv2zqq5y">
                <span className="font-semibold text-white" data-id="element-219" data-mp="1kvhph9uyj0ul">{f.title}.</span> {f.body}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}